import { render, staticRenderFns } from "./DashboardParent.vue?vue&type=template&id=7c3e9899&scoped=true"
import script from "./DashboardParent.vue?vue&type=script&lang=js"
export * from "./DashboardParent.vue?vue&type=script&lang=js"
import style0 from "./DashboardParent.vue?vue&type=style&index=0&id=7c3e9899&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3e9899",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c3e9899')) {
      api.createRecord('7c3e9899', component.options)
    } else {
      api.reload('7c3e9899', component.options)
    }
    module.hot.accept("./DashboardParent.vue?vue&type=template&id=7c3e9899&scoped=true", function () {
      api.rerender('7c3e9899', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardParent.vue"
export default component.exports